<template>
  <div class="paragraph-block" @click="onInternalLinkClick" v-html="block.value"></div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
import {useInternalLinks} from '@/composables/useInternalLinks';
defineProps<{block: SphereBlock<'paragraph_block'>}>();
const {onInternalLinkClick} = useInternalLinks();
</script>
<style lang="scss" scoped>
// Bold uses the semi-bold weight of the heading scale (h5/h6 = 600), at the paragraph's own size.
:deep(strong),
:deep(b) {
  font-weight: 600;
}

// A heading keeps its weight from the heading scale, bold markup inside it doesn't override it.
:deep(:is(h1, h2, h3, h4, h5, h6) :is(strong, b)) {
  font-weight: inherit;
}
</style>
